<template>
  <div>
    <v-img :src="require('@/assets/img-about-us-inner.jpg')" />
    <v-container class="py-4 mb-8">
      <div
        class="text-h1 font-medium line-bottom text-uppercase"
        :class="$store.state.mobile ? 'mb-10' : 'my-6'"
      >
        <template v-if="$store.getters.languageGetter === '1'">
          معلومات عنا
        </template>
        <template v-else>
          About Us
        </template>
      </div>
      <div v-html="$store.getters.languageGetter === '1' ? webConfig.aboutUs : webConfig.aboutUsEn" />
    </v-container>
    <news-letter />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NewsLetter from '@/layout/NewsLetter.vue';

export default {
  name: 'AboutUs',
  components: {
    NewsLetter,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState(['webConfig']),
  },
};
</script>
